<template>
  
  <div v-if="this.vh1Value == 28 && this.vh2Value == 38" class="p-12">
      <div v-if="isMobile">
        <center><img src="@/assets/rotatedevice.jpg" class=""></center>
        <h3>Kindly switch your device to landscape mode, or if you're still encountering this message, please use the CSTap mobile application.</h3>
      </div>

      <div v-else>
        <center><img src="@/assets/maximizescreensize.png" class="h-28"></center>
        <h3>Kindly maximize your [MS Teams] or [Browser] and make sure your screen resolution is at least “1280x720” to fully support the CS Tap Web application.</h3>
      </div>
  </div>

  <div v-else class="card lg:card-side blue-card w-[70%] lg:mr-12 rounded-3xl lg:ml-12 md:h-90vh lg:h-90vh z-1 mb-10 mt-10">
    <div class="grid lg:grid-cols-1 md:grid-cols-2 grid-cols-1 gap-4 lg:px-6 md:px-4 py-6 w-full"> 
      <div class="flex flex-col overflow-y-auto max-h-[90vh]">
        <div class="container">
          
          <h1>Privacy Policy</h1>

          <div class="sub-container">

            <div class="section">
              <strong>1. Privacy Policy</strong>
              <ul class="list-disc pl-5" style="margin-left: 25px;">
                <li data-label="a.">This Privacy Policy describes the policies and procedures on the collection, use, and disclosure of the information collected from using the Application or the Services included in the Application, in which describes your rights and how the law protects you as a user of the Application. </li>
                <li data-label="b.">By using the Application and the Services that it provides, you agree to the collection and use of information in accordance with this Privacy Policy.</li>
              </ul>
            </div>

            <div class="section">
              <strong>2. Definitions</strong>
              <ul class="pl-5" style="margin-left: 25px;">
                <li data-label="a."><strong>Account</strong> means the account authenticated by username and password, to access the Application.</li>
                <li data-label="b."><strong>Affiliates</strong> means the company’s parent company and any subsidiaries, joint venture partners or other companies that are under the company’s control or that are under common control with the company.</li>
                <li data-label="c."><strong>Application</strong> means the software program provided by Cloudstaff downloaded by you on any electronic device, named CS website.</li>
                <li data-label="d."><strong>Cookies</strong> are small files that are placed on your computer, website device or any other device by a website, containing the details of your browsing history on that website among its many uses.</li>
                <li data-label="e."><strong>Device</strong> means any device that can access the Service such as a computer, a cell phone or a digital tablet.</li>
                <li data-label="f."><strong>Profile</strong> means the profile created by the Client and Employee that may include personal information of the Client, Employee, and Staff.</li>
                <li data-label="g."><strong>Service</strong> means any services provided by Cloudstaff through the Application;</li>
                <li data-label="h."><strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of Cloudstaff. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.</li>
                <li data-label="i."><strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the website or from the Service infrastructure itself (for example, the duration of a page visit).</li>
                <li data-label="j."><strong>Staff</strong> means a person engaged or employed by Cloudstaff;</li>
                <li data-label="k."><strong>User</strong> refers to any individual or entity that uses any aspect of the Application and/or the Services.</li>
                <li data-label="l."><strong>You or your</strong> means the person who (or the entity on behalf of whom you are acting) that is agreeing to these Terms.</li>
              </ul>
            </div>

            <div class="section">
              <strong>3. User Content and submissions</strong>
              <ul class="pl-5" style="margin-left: 25px;">
                <li data-label="a.">You understand that all User Content is the sole responsibility of the person from which such User Content originated.</li>
                <li data-label="b.">You understand and acknowledge that all information provided by you, your Cloudstaff Website Profile and/or account information shall be stored in Cloudstaff Databases and/or Cloudstaff Website Application.</li>
                <li data-label="c.">We may ask you to provide us with certain personal information that can be used to contact or identify you. Personal information may include, but is not limited to:</li>
                <li data-label="d."><strong>User Feedback:</strong> helps the developers to understand what users like or dislike about the app. This can help them to improve the user experience and increase user satisfaction.</li>
                <li data-label="e."><strong>Feature Request:</strong> User requests can provide developers with ideas for future development of the website app. Users may suggest new features, improvements, or changes that the developers can consider when planning updates to the app.</li>
                <li data-label="f."><strong>Support Needed:</strong> This includes answering questions, providing guidance, and troubleshooting technical issues.</li>
                <li data-label="g."><strong>Request Account Details:</strong> First Name, Last Name, Business Email, and Company Name will be needed for the purpose of client verification and creation of an account to access the product and other.</li>
                <li data-label="h."><strong>Hire People Request Role Details:</strong> Providing clear and accurate role details is crucial in ensuring that the hiring process is efficient and effective. By outlining the specific requirements and responsibilities of the job position, role details can help to attract the right candidates, set expectations, streamline the hiring process, and ensure compliance with legal and regulatory requirements.</li>
              </ul>
            </div>

            <div class="section">
              <strong>4. Usage Data</strong>
              <ul class="pl-5" style="margin-left: 25px;">
                <li data-label="a.">When using the Services of the Application, Usage Data is collected automatically, this includes, but not limited to:
                  <ul class="pl-5" style="margin-left: 25px;">
                    <li data-label="i.">website device’s unique ID, IP address, and operating system;</li>
                    <li data-label="ii.">unique device identifiers and other diagnostic data.</li>
                  </ul>
                </li>
              </ul>
            </div>

            <div class="section">
              <strong>5. Use of Personal Information</strong>
              <ul class="pl-5" style="margin-left: 25px;">
                <li data-label="a.">While using Cloudstaff Website Application, in order to provide features of Our Application, we may collect information, with your prior permission for the following purposes:
                  <ul class="pl-5" style="margin-left: 25px;">
                    <li data-label="i.">To manage your Account.</li>
                      <ul class="list-disc pl-5" style="margin-left: 25px; list-style-type: disc;">
                        <li>To manage your registration as a user of the website; </li>
                        <li>The collected information can give you access to different functionalities of the website that are available to you. </li>
                      </ul>
                    <li data-label="ii.">To manage your requests.</li>
                      <ul class="list-disc pl-5" style="margin-left: 25px; list-style-type: disc;">
                        <li>To attend, manage, and give support to your requests.</li>
                      </ul>
                    <li data-label="iii.">To improve the Application.</li>
                      <ul class="list-disc pl-5" style="margin-left: 25px; list-style-type: disc;">
                        <li>To ensure user satisfaction, future development, and improvements of the Application.</li>
                      </ul>
                    <li data-label="iv.">For other purposes:</li>
                      <ul class="list-disc pl-5" style="margin-left: 25px; list-style-type: disc;">
                        <li>We may use the collected information for other purposes, such as data analysis, identifying usage trends, to evaluate and improve our website, products, services, marketing and your experience.</li>
                      </ul>
                  </ul>
                </li>
              </ul>
            </div>

            <div class="section">
              <strong>6. Transfer of Personal Information</strong>
              <ul class="pl-5" style="margin-left: 25px;">
                <li data-label="a.">We may share your personal information in the following situations:
                  <ul class="pl-5" style="margin-left: 25px;">
                    <li data-label="i."><strong>With our Affiliates:</strong> We may share your information with our Affiliates, including parent and subsidiaries, who must comply with this Privacy Policy when sharing information.</li>
                    <li data-label="ii."><strong>With other users:</strong> When you share personal information, such information may be viewed by all users and may be publicly distributed outside. Access control is limited only to the functionalities of the Service that are only available to you.</li>
                    <li data-label="iii."><strong>With your consent:</strong> We may disclose your personal information for any other purpose with your consent.</li>
                  </ul>
                </li>
                <li data-label="b.">Your consent to this Privacy Policy, followed by your submission of such information, represents your agreement to that transfer.</li>
                <li data-label="c.">You have the right to opt-out of the sale or sharing of your personal information with third parties. This means you can direct us not to sell or share your personal information for any commercial purpose not directly related to your use of our services:
                  <ul class="pl-5" style="margin-left: 25px;">
                    <li data-label="i.">Your opt-out request will not apply to certain necessary disclosures, such as those to our Affiliates as outlined in this Privacy Policy, or any other disclosures required by law or necessary to provide you with requested services.</li>
                    <li data-label="ii.">Exercising your opt-out rights will not result in any discriminatory treatment or impact on the availability of services provided to you.</li>
                  </ul>
                </li>
              </ul>
            </div>

            <div class="section">
              <strong>7. Non-Discrimination for Exercising Privacy Rights</strong>
              <ul class="pl-5" style="margin-left: 25px;">
                <li data-label="a.">We are committed to ensuring that you can freely exercise your privacy rights without facing any form of discrimination. Specifically, if you choose to exercise your rights under this Privacy Policy, including the right to access, delete, or opt-out of the sale or sharing of your personal information, you will not be subjected to:
                  <ul class="pl-5" style="margin-left: 25px;">
                    <li data-label="i.">Denial of services.</li>
                    <li data-label="ii.">Variation in the quality of services received.</li>
                    <li data-label="iii.">Provision of a different level of service.</li>
                  </ul>
                </li>
                <li data-label="b.">This means that exercising your privacy rights will not affect your access to our services or our commitment to delivering high-quality service experiences. If you believe you have been subjected to discriminatory behavior related to your privacy rights, please contact us at <a href="mailto:privacy@cloudstaff.com">privacy@cloudstaff.com</a> so we can address and resolve the issue promptly.</li>
              </ul>
            </div>

            <div class="section">
              <strong>8. Retention of your personal information</strong>
              <ul class="pl-5" style="margin-left: 25px;">
                <li data-label="a.">Cloudstaff will retain the information collected for as long as it is necessary for the purposes set out in this Privacy Policy;</li>
                <li data-label="b.">The data obtained from the Content, Profile, Database or Application shall not be kept longer than is necessary for the fulfillment of the purposes set out in this Section. In this respect, you agree and undertake to delete, destroy and/or purge such data or any derivatives thereof from your records.</li>
                <li data-label="c.">You understand and acknowledge that you have no ownership rights in your account and that if you cancel your Account or your Account is terminated, all your account information from Database or Website, including your Profile, will remain in the Database at the discretion of Cloudstaff. In addition, the Employees and/or the Clients may retain saved copies of your information or Profile.</li>
              </ul>
            </div>

            <div class="section">
              <strong>9. Third-Party Providers</strong>
              <ul class="pl-5" style="margin-left: 25px;">
                <li data-label="a.">Third parties may retain cached copies of User information;</li>
                <li data-label="b.">We may share your information with third parties that perform services for us or on our behalf, including data analysis, email delivery, hosting services, and customer service.</li>
                <li data-label="c."><strong>Analytics:</strong>
                  <ul class="pl-5" style="margin-left: 25px;">
                    <li data-label="i.">We use tools like Google Analytics to understand how you use our website. This includes collecting information about:
                      <ul class="list-disc pl-5" style="margin-left: 25px; list-style-type: disc;">
                        <li>IP address</li>
                        <li>Browser type</li>
                        <li>Device information</li>
                        <li>Pages visited</li>
                        <li>Time spent on the website</li>
                        <li>This information is used to improve our website’s performance and user experience.</li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li data-label="d."><strong>Email Marketing:</strong>
                  <ul class="pl-5" style="margin-left: 25px;">
                    <li data-label="i.">We use services like HubSpot to send you marketing emails, such as newsletters and promotions. We collect your email address and any other information you provide for this purpose. We only send these emails if you agree to receive them, and you can unsubscribe anytime using the link in the email or by contacting us.</li>
                  </ul>
                </li>
                <li data-label="e."><strong>Advertising:</strong>
                  <ul class="pl-5" style="margin-left: 25px;">
                    <li data-label="i.">We use advertising services like Google Ads to show you relevant ads. These ads might be based on your browsing history and other information we collect. We may also use technologies that track your browsing on our site and others to target ads more effectively.</li>
                  </ul>
                </li>
                <li data-label="f.">We are committed to safeguarding your privacy and personal data. All third-party tools and services are evaluated for compliance with applicable data protection laws. We continuously monitor and update our policies to reflect changes in the legal landscape or in the usage of third-party services.</li>
              </ul>
            </div>

            <div class="section">
              <strong>10. Links to Other Applications</strong>
              <ul class="pl-5" style="margin-left: 25px;">
                <li data-label="a.">Cloudstaff is not responsible for content on any site outside the Cloudstaff Website Application. We strongly advise you to review the Privacy Policy of every site you visit
                </li>
              </ul>
            </div>

            <div class="section">
              <strong>11. Messaging Services</strong>
              <ul class="pl-5" style="margin-left: 25px;">
                <li data-label="a.">The following terms related to messaging services via a 10-digit long code apply solely to Cloudstaff users located within the United States:
                  <ul class="pl-5" style="margin-left: 25px;">
                    <li data-label="i."><strong>Message and Data Rates:</strong> When utilizing Cloudstaff’s messaging services via a 10-digit long code, please be aware that your mobile carrier may apply message and data rates according to your plan. You bear responsibility for any fees incurred.</li>
                    <li data-label="ii."><strong>Message Frequency:</strong> The frequency of messages sent through our services can vary based on your engagement and the necessity for updates or notifications. Cloudstaff ensures a balanced approach to enhance user experience without excessive messaging.</li>
                    <li data-label="iii."><strong>Opt-Out Information:</strong> You have the option to discontinue receiving messages at any time by replying “STOP” to any message received from us via the 10-digit long code. Upon receipt of your opt-out request, Cloudstaff will promptly remove you from our messaging list.</li>
                    <li data-label="iv."><strong>Data Privacy:</strong>
                      <ul cclass="list-disc pl-5" style="margin-left: 25px; list-style-type: disc;">
                        <li>Mobile opt-in data collected and processed via the 10-digit long code, including your mobile number and any related communication preferences, will be kept strictly confidential.</li>
                        <li>This data will remain private and will not be shared with any third parties.</li>
                        <li>The only exceptions to this commitment include circumstances where disclosure is required by applicable law, regulation, or legal process, or where it is essential to facilitate, comply, and manage the services you have specifically requested. Cloudstaff’s security practices keep your data safe and only allow access to those who need it to provide our services.</li>
                      </ul>
                    </li>
                    <li data-label="v."><strong>Support Contact:</strong> For assistance or additional information concerning our messaging service, please contact us at <a href="mailto:security@cloudstaff.com" target="_blank" rel="noreferrer noopener">security@cloudstaff.com</a>. We are committed to providing support and addressing any queries you may have.</li>
                  </ul>
                </li>
              </ul>
            </div>

            <div class="section">
              <strong>12. Disclosure of Personal Information</strong>
              <ul class="pl-5" style="margin-left: 25px;">
                <li data-label="a.">Cloudstaff may collect certain User information and may contact Users periodically in accordance with the terms of this Privacy Policy. In addition, Cloudstaff reserves the right to comply, in its sole discretion, with legal requirements, requests from law enforcement agencies or requests from government entities, even to the extent that such compliance may require disclosure of certain User information.</li>
              </ul>
            </div>

            <div class="section">
              <strong>13. Security of Personal Information</strong>
              <ul class="pl-5" style="margin-left: 25px;">
                <li data-label="a.">Businesses can ensure data confidentiality by controlling who has access to non-public information, documents, files, etc. Access control should always be based on the principle of least privilege, which means that you should only grant access to data on a need-to-know basis.</li>
                <li data-label="b.">If Cloudstaff has reason to believe that there is likely to be a breach of security or misuse of the Application, we may require you to change your password or we may suspend your account immediately.</li>
                <li data-label="c.">You shall be strictly liable and/or responsible for all uses of your Account registrations and passwords, whether or not authorized by you.</li>
                <li data-label="d.">As a result of your loss of your password or the misuse of the Application:
                  <ul class="pl-5" style="margin-left: 25px;">
                    <li data-label="i.">All losses or damages incurred thereby shall be borne by you; and</li>
                    <li data-label="ii.">You shall fully indemnify Cloudstaff should the Application suffer any loss, damage, or payment of fine from any regulatory or legal authority.</li>
                  </ul>
                </li>
              </ul>
            </div>

            <div class="section">
              <strong>14. Modification to Privacy Policy</strong>
              <ul class="pl-5" style="margin-left: 25px;">
                <li data-label="a.">We reserve the right, at our discretion, to change the Policy from time to time. An email will be sent out if changes to the Policy have been applied. Please check the Policy periodically for changes;</li>
                <li data-label="b.">Your access to the Cloudstaff Website Application may be occasionally restricted and the Service may be unavailable in order to allow for repairs, maintenance, or the introduction of new content, facilities, or services. We will attempt to restore access and/or service as soon as we reasonably can.</li>
                <li data-label="c.">Cloudstaff may terminate, suspend, update, alter or supplement, at its sole discretion, all or any part of the Application at any time. By permitting access to the Application, Cloudstaff does not convey any interest in or to the Content or any other Cloudstaff property or Services. All right, interest in and to the Cloudstaff Website Application is and shall remain in Cloudstaff.</li>
              </ul>
            </div>

            <div class="section">
              <strong>15. Contact Information</strong>
              <ul class="pl-5" style="margin-left: 25px;">
                <li data-label="a.">If you have any queries, please contact us at <a href="mailto:privacy@cloudstaff.com">privacy@cloudstaff.com</a>.</li>
                <li data-label="b.">We will send notice to you at the address submitted by you or to such other address as Cloudstaff reasonably determines is an appropriate address for you.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

  a {
    color: blue;
  }

  .sub-container {
    margin-left: 100px;
    text-align: left;
    width: 100%;
  }

  .container {
    max-width: 800px;
    margin-left: 60px;
    text-align: left;
    width: 75%;
    margin-bottom: 50px;
    word-wrap: break-word;
  }

  h4 {
    color: #1b2597;
    font-size: 1.8rem;
    margin-bottom: 1rem;
    font-weight: bolder;
  }

  p, li {
    font-size: 1rem;
    line-height: 1.6;
  }

  .section {
    margin-bottom: 2rem;
  }

  .section ul {
    list-style-type: none; /* Remove bullet dots */
    padding-left: 1.5rem;   /* Space for indenting */
    margin-top: 0.5rem;
  }

  .section li {
    text-indent: -1.2em;    /* Pull label into left margin */
    padding-left: 1.8em;    /* Space after label */
    margin-bottom: 0.5em;
  }

  .section li::before {
    content: attr(data-label);
    font-weight: bold;
    margin-right: 0.3em;
  }

  .flex.flex-col {
    overflow-y: auto;
    max-height: 90vh;
    overflow-x: hidden;
  }
</style>


<script>

import { mapGetters } from 'vuex';

export default {
data: function () {
    return {
        isMobile: false,
        vh1Value: 55,
        vh2Value: 65, // Initial value, change as needed
        vh3Value: 90, // Initial value, change as needed
    }
},
computed:{
  ...mapGetters(['authenticated']),
},
beforeUnmount() {
  window.removeEventListener('resize', this.updatevhValue);
  window.removeEventListener('resize', this.detectMobile);
},
mounted() {
  this.detectMobile();
  window.addEventListener('resize', this.detectMobile);
  window.addEventListener('resize', this.updatevhValue);
  this.updatevhValue();
},
methods: {
  detectMobile() {
    const userAgentCheck = /Mobile|Android|iPhone|iPad/i.test(navigator.userAgent) && navigator.userAgentData?.platform !== 'Windows' && navigator.userAgentData?.platform !== 'macOS';
    this.isMobile = userAgentCheck;
  },
  updatevhValue() {
        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;
  
        if (screenWidth >= 1537 && screenHeight >= 769.80) {
          this.vh3Value = 90;
          this.vh2Value = 68;
          this.vh1Value = 58;
        } else if (screenWidth >= 1253 && screenHeight >= 578) {
          this.vh3Value = 82;
          this.vh2Value = 60;
          this.vh1Value = 48;
        } else if (screenWidth >= 1025 && screenHeight >= 500) {
          this.vh3Value = 72;
          this.vh2Value = 50;
          this.vh1Value = 38;
        } else {
          this.vh3Value = 50;
          this.vh2Value = 38;
          this.vh1Value = 28;
        }
  },
}

}

</script>
